export enum APP_NAMES {
    PLANNING,
    PORTAIL,
    COMMON,
    ERROR,
    ALERT,
    COMPONENTS
}

export const LOCALES = {
    FR: "_fr",
    EN: "_en"
};